<script>
import {
  CdrText,
  CdrLink,
  CdrImg,
} from '@rei/cedar';
import analytics from '../../common/analytics';

export default {
  name: 'GiftcardMobileComponent',
  components: {
    CdrText,
    CdrLink,
    CdrImg,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    appstore: {
      type: Object,
      required: true,
    },
    playstore: {
      type: Object,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    pageDescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      analytics,
    };
  },
  computed: {
    validProps() {
      return (this.title && this.description && (typeof this.appstore !== 'undefined') && (typeof this.playstore !== 'undefined'));
    },
  },
  methods: {
    sendClickEvent(name) {
      this.analytics.click({ linkName: `${this.siteId}:${this.pageDescription}_${name}` });
    },
  },
};
</script>

<template>
  <div
    v-if="validProps"
    data-ui="mobile-content"
    class="giftcard-mobile__content"
  >
    <cdr-text
      class="giftcard-mobile__title"
      tag="h1"
      data-ui="gift-card-heading-app"
    >
      {{ title }}
    </cdr-text>
    <cdr-text
      class="giftcard-mobile__description"
      tag="p"
      data-ui="gift-card-forget-information"
    >
      {{ description }}
    </cdr-text>
    <div class="giftcard-mobile__container-image">
      <cdr-link
        :href="appstore.url"
        target="_blank"
        modifier="standalone"
        data-ui="mobile-appstore"
        @click="sendClickEvent('app store')"
      >
        <cdr-img
          class="giftcard-mobile__image-appstore"
          :src="appstore.srcImg"
          alt="App store REI"
          loading="lazy"
        />
      </cdr-link>
      <cdr-link
        :href="playstore.url"
        target="_blank"
        modifier="standalone"
        data-ui="mobile-playstore"
        @click="sendClickEvent('play store')"
      >
        <cdr-img
          class="giftcard-mobile__image-playstore"
          :src="playstore.srcImg"
          alt="Play store REI"
          loading="lazy"
        />
      </cdr-link>
    </div>
  </div>
</template>
